<template>
  <q-timeline color="primary-50">
    <slot></slot>
  </q-timeline>
</template>

<script setup></script>

<style lang="scss" scoped>
.q-timeline {
  &--dense {
    &--right {
      :deep(.q-timeline__entry) {
        padding-left: 24px;
      }

      :deep(.q-timeline__dot::before) {
        color: $primary-50;

        height: 10px;
        width: 10px;

        left: 1px;
        top: 6px;
      }

      :deep(.q-timeline__dot:after) {
        color: $primary-50;

        opacity: 1;

        bottom: -16px;
        left: 5px;
        top: 16px;

        width: 1px;
      }

      :deep(.q-timeline__subtitle) {
        margin-bottom: 0;
        text-transform: none;
      }
    }
  }
}
</style>
